<template>
  <div class="noteTable">
    <van-row style="margin-bottom: 10px">
      <van-col span="12">检测时间</van-col>
      <van-col span="6">检测数值</van-col>
      <van-col span="6">结果评估</van-col>
    </van-row>
    <van-row v-for="(item, index) in list" :key="index" class="noteTableItem">
      <van-col span="12">{{ item.created_at }}</van-col>
      <van-col span="6">{{ item.value }}</van-col>
      <van-col span="6" v-show="item.status == '减弱'" class="jr">
        {{ item.status }}<img :src="colorsImg[2]"
      /></van-col>
      <van-col span="6" v-show="item.status == '普通'" class="ph">
        {{ item.status }} <img :src="colorsImg[0]"
      /></van-col>
      <van-col span="6" v-show="item.status == '加强'" class="jq">
        {{ item.status }}<img :src="colorsImg[1]"
      /></van-col>
    </van-row>
  </div>
</template>
<script>
export default {
  props: ['list'],
  data () {
    return {
      lev: 0,
      colorsImg: [
        require('../../../assets/image/chang/pingheng.png'),
        require('../../../assets/image/chang/jiaqiang.png'),
        require('../../../assets/image/chang/jianruo.png'),
      ],
    }
  },
  watch: {

  },
  created () {
    this.keyLr()
  },
  methods: {
    keyLr () {

    }
  }
}
</script>
<style lang="scss" scoped>
.noteTable {
  text-align: center;
  font-size: 28px;
  .noteTableItem {
    margin-bottom: 10px;
  }
}
.noteTable img {
  width: 31px;
  height: 12px;
  vertical-align: middle;
  margin-left: 5px;
}
.jr {
  color: #3195e6;
}
.jq {
  color: #f1be33;
}
.ph {
  color: #8be31b;
}
</style>